__turbopack_context__.v({
  "CollaborationBadgeWrap": "ProgramCard-module-scss-module__XuHmCq__CollaborationBadgeWrap",
  "Collaborationimg": "ProgramCard-module-scss-module__XuHmCq__Collaborationimg",
  "card": "ProgramCard-module-scss-module__XuHmCq__card",
  "content": "ProgramCard-module-scss-module__XuHmCq__content",
  "description": "ProgramCard-module-scss-module__XuHmCq__description",
  "footer": "ProgramCard-module-scss-module__XuHmCq__footer",
  "footerDuration": "ProgramCard-module-scss-module__XuHmCq__footerDuration",
  "footerFee": "ProgramCard-module-scss-module__XuHmCq__footerFee",
  "footerInnerContainer": "ProgramCard-module-scss-module__XuHmCq__footerInnerContainer",
  "footerItem": "ProgramCard-module-scss-module__XuHmCq__footerItem",
  "image": "ProgramCard-module-scss-module__XuHmCq__image",
  "imageArea": "ProgramCard-module-scss-module__XuHmCq__imageArea",
  "imagePlaceholder": "ProgramCard-module-scss-module__XuHmCq__imagePlaceholder",
  "info": "ProgramCard-module-scss-module__XuHmCq__info",
  "partnerBadge": "ProgramCard-module-scss-module__XuHmCq__partnerBadge",
  "partnerLabel": "ProgramCard-module-scss-module__XuHmCq__partnerLabel",
  "partnerName": "ProgramCard-module-scss-module__XuHmCq__partnerName",
  "qsBadge": "ProgramCard-module-scss-module__XuHmCq__qsBadge",
  "qsBadgeWrap": "ProgramCard-module-scss-module__XuHmCq__qsBadgeWrap",
  "startingPriceLabel": "ProgramCard-module-scss-module__XuHmCq__startingPriceLabel",
  "tag": "ProgramCard-module-scss-module__XuHmCq__tag",
  "tags": "ProgramCard-module-scss-module__XuHmCq__tags",
  "title": "ProgramCard-module-scss-module__XuHmCq__title",
});
